import api from './api'
import categories from './categories/api'
import siteVersions from '../site-versions/api'

export default {
  namespaced: true,
  state: {
    routeKey: 'faqsId',
    routes: {
      index: 'faqs.index',
      create: 'faqs.create',
      edit: 'faqs.edit'
    },
    table: [
      { code: 'site_versions', type: 'function', get: data => data.map(item => item.name).join(', ') },
      { code: 'weight', type: 'integer', sort: true },
      { code: 'publish', type: 'boolean' },
      { code: 'code', type: 'string', sort: true },
      { code: 'question', type: 'string' },
      { code: 'category', type: 'function', get: data => data?.name },
      { code: 'created_at', type: 'datetime', sort: true },
      { code: 'updated_at', type: 'datetime', sort: true }
    ],
    form: [
      { code: 'site_versions', type: 'multiselect', options: [], size: 6, validation: { required: true } },
      { code: 'publish', type: 'boolean' },
      { code: 'weight', type: 'text', validation: { required: true, integer: true } },
      { code: 'code', type: 'text', validation: { required: true } },
      { code: 'category_id', type: 'select', options: [], validation: { integer: true } },
      { code: 'question', type: 'text', validation: { required: true } },
      { code: 'answer', type: 'textarea' }
    ],
    item: {},
    items: [],
    meta: {},
    page: 1,
    sort: 'weight'
  },
  mutations: {
    SET_ITEMS (state, data) {
      state.items = data.data || null
      state.meta = data.meta || null
    },
    SET_ITEM (state, data) {
      state.item = {
        id: data.id || null,
        locales: data.locales || [],
        site_versions: data.site_versions?.map(item => item.id) || [],
        weight: data.weight || null,
        category_id: data.category?.id || null,
        publish: data.publish === true ? 1 : null,
        code: data.code || null,
        question: data.question || null,
        answer: data.answer || null
      }
    },
    SET_SELECT_OPTIONS (state, { code, options }) {
      state.form.find(item => item.code === code).options = options
    },
    SET_SORT (state, field) {
      state.sort = state.sort === field ? `-${field}` : field
    },
    SET_PAGE (state, page) {
      state.page = page
    }
  },
  actions: {
    clearItem ({ commit }) {
      commit('SET_ITEM', {})
    },
    async fetchCategories ({ commit }) {
      const { data: { data } } = await categories.index({
        'sort': 'weight',
        'page[all]': true
      })

      const options = data.map(item => ({
        value: item.id,
        text: item.name
      }))

      commit('SET_SELECT_OPTIONS', { code: 'category_id', options })
    },
    async fetchSiteVersions ({ commit }) {
      const { data: { data } } = await siteVersions.index({
        'sort': 'weight',
        'page[all]': true
      })

      const options = data.map(item => ({
        value: item.id,
        text: item.name
      }))

      commit('SET_SELECT_OPTIONS', { code: 'site_versions', options })
    },
    async fetchItems ({ commit, state }) {
      const { data } = await api.index({
        'sort': state.sort,
        'page[number]': state.page
      })

      commit('SET_ITEMS', data)
    },
    async fetchItem ({ commit }, { route }) {
      const { data: { data } } = await api.show(route.params.faqsId)

      commit('SET_ITEM', data)
    },
    async createItem ({ commit }, { form }) {
      const { data: { data } } = await api.store(form)

      commit('SET_ITEM', data)
    },
    async updateItem ({ commit }, { route, form }) {
      const { data: { data } } = await api.update(route.params.faqsId, form)

      commit('SET_ITEM', data)
    },
    async deleteItem (_, { id }) {
      await api.destroy(id)
    }
  }
}
